import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import ActionsApi from '../../services/api/ActionsApi';
import { showError } from '../../utils/utils';

const setActionsLoading = createAction<{ type: 'info'; value: boolean }>(
  'actions/setLoading'
);

const fetchActionsInfo = createAsyncThunk(
  'actions/fetchActionsInfo',
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(setActionsLoading({ type: 'info', value: true }));
      const response = await ActionsApi.getActionsInfo();

      if (response.status === 200) {
        return response.data;
      }
      return undefined;
    } catch (err) {
      showError(err, thunkAPI);
    } finally {
      thunkAPI.dispatch(setActionsLoading({ type: 'info', value: false }));
    }
  }
);

export { fetchActionsInfo, setActionsLoading };
